import { render } from "./vluckydrawrecord.vue?vue&type=template&id=ffedd93e&scoped=true"
import script from "./vluckydrawrecord.vue?vue&type=script&lang=js"
export * from "./vluckydrawrecord.vue?vue&type=script&lang=js"

import "./vluckydrawrecord.vue?vue&type=style&index=0&id=ffedd93e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffedd93e"]])

export default __exports__